// https://sp.circlechess.com/v1/generate_payment_links

import {useMutation} from '@tanstack/react-query';
import ChessPaymentRestClient from '@/Api/ChessPaymentRestClient';

interface PaymentApiParams {
  tournament_id?: number;
  player_id?: number;
  category_str?: string;
  customer_id: any;
  mobile_number: any;
  email: string;
  subscription_plan_id?: number;
  amount: number;
  return_url: string;
  child_tournament_id?: number;
}

export default function useGeneratePaymentApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, PaymentApiParams>(
    async body => {
      const {amount = 100, ...payload} = body;
      const response = await ChessPaymentRestClient.post(
        amount > 0
          ? 'v1/generate_payment_links'
          : 'v1/confirm_registration_without_payment',
        payload,
      );

      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
